import { TaskListItem } from './task-list-item';
import { OrderReturnItem } from './order-return-item';

export class RefundingTaskListItem extends TaskListItem {
    public orderReturnItemList: OrderReturnItem[];
    public notes: string;
    public totalRefundPrice: number;
    public customerPhone: number;
}
